import { apiClient } from "./client";
import type { TenantThemeOverride } from "../theme/tokens";

const ENDPOINT = "/tenants/current/theme-config";

export interface TenantThemeConfig {
  overrides: TenantThemeOverride;
}

export interface UpdateTenantThemeConfigPayload {
  overrides: TenantThemeOverride;
}

export const tenantThemeApi = {
  getConfig: async (): Promise<TenantThemeConfig> => {
    const response = await apiClient.get<TenantThemeConfig>(ENDPOINT);
    return response.data;
  },
  updateConfig: async (
    payload: UpdateTenantThemeConfigPayload,
  ): Promise<TenantThemeConfig> => {
    const response = await apiClient.put<TenantThemeConfig>(ENDPOINT, payload);
    return response.data;
  },
};
